<template>
  <div class="container">
    <div v-if="addressVal.area" class="my_address" @click="address">
      <van-icon name="location-o" />
      <div class="my_main_address">
        {{addressVal.name}}   {{addressVal.mobile}}
      </div>
      <div class="address">{{addressVal.area + '' + addressVal.address}}</div>
      <van-icon name="arrow" />
    </div>
    <div v-if="!addressVal.area" class="no_address" @click="address">
      <van-icon name="plus" />
      <p>添加收货地址</p>
    </div>

    <div class="cart_pro_list">
      <div class="list">
        <pro-item v-for="(item, index) of list" :key="index" :productItem="item"></pro-item>
      </div>
      <div class="numtotal">
        <span>共{{totalnum}}件</span>
        <span>合计：<span class="totalprice">¥0.00</span></span>
      </div>
    </div>
    <div class="additional">
      <van-cell-group>
        <van-field class="field" maxlength="45" v-model="remark" label="订单备注" placeholder="选填，最多45字，请先和客服协商一致" />
      </van-cell-group>
    </div>
    <div class="sub_bar">
      <div class="itemtxt">需付款:<span class="xprice">
        <sub>¥</sub>
        <b>0</b>
        <sup>.00</sup>
      </span>
      </div>
      <div class="btton" @click="goNext">提交订单</div>
    </div>
  </div>
</template>

<script>
import proItem from '../common/cart_pro_item'
import { customRequestAjax } from '@/axiosApi'
import { isWeixin, fenxiang } from '../../assets/common/js/config'

export default {
  name: 'addOrderPrize',
  data () {
    return {
      list: [],
      totalnum: 0,
      addressVal: {},
      remark: ''
    }
  },
  components: {
    proItem
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({path: 'addorderprize'})
    }
    this.getData()
    if (sessionStorage.getItem('prize_choose_list')) {
      this.list = JSON.parse(sessionStorage.getItem('prize_choose_list'))
      this.totalnum = this.list.length
    }
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
    sessionStorage.removeItem('choose_address')
  },
  methods: {
    getData: function () {
      var urlAddress = 'Wxmall/Address/getDefaultAddress'
      var that = this
      if (JSON.parse(sessionStorage.getItem('choose_address'))) {
        that.addressVal = JSON.parse(sessionStorage.getItem('choose_address'))
      } else {
        customRequestAjax(urlAddress).then(res => {
          if (res.data.code === 200) {
            that.addressVal = res.data.addressdata
          }
        })
      }
    },
    goNext () {
      var url = 'Wxmall/Order/addOrderByPrizes'
      var prizeids = [], actprizeid = []
      this.list.map(item => {
        if (item.actprizeid) {
          actprizeid.push(item.actprizeid)
        } else {
          prizeids.push(item.prize_id)
        }
      })
      var data = {
        addressid: this.addressVal.id,
        remark: (this.remark != null || this.remark != undefined) ? this.remark : ''
      }

      if (actprizeid.length) data.actprizeid = actprizeid.join()
      if (prizeids.length) data.prizeids = prizeids.join()

      customRequestAjax.post(url, data).then(res => {
        if (res.data.code === 200) {
          this.$router.replace({path: '/orderdetails',
            query: {
              id: res.data.orderid
            }
          })
        }
      })
    },
    address: function () {
      this.$router.replace({
        path: '/addresschoose',
        query: {
          chooseid: this.$route.query.chooseid,
          type: 'submitorderprize'
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  padding-bottom: .6rem;
  .my_address {
    margin: .11rem;
    background: #fff;
    border-radius: .04rem;
    padding:.15rem 0;
    padding-left: .47rem;
    position: relative;
    .my_main_address {
      font-size: .16rem;
      line-height: .22rem;
      color: #222222;
      font-weight: 600;
    }
    .address{
      font-size: .12rem;
      line-height: .17rem;
      color:#999;
      margin-top: .04rem;
      padding-right: .3rem;
      height: 0.34rem;
      overflow: hidden;
    }
    .van-icon-location-o{
      position: absolute;
      top:.35rem;
      left:.17rem;
      font-size: .19rem;
    }
    .van-icon-arrow{
      position: absolute;
      top:.35rem;
      right:.15rem;
      font-size: .16rem;
      color:#1D1E1E;
    }
  }
  .no_address {
    padding: 0.13rem 0.15rem;
    background:rgba(255,255,255,1);
    border-radius:0.04rem;
    font-size: 0;
    margin: .11rem;
    .van-icon-plus {
      font-size:0.15rem;
      line-height:0.21rem;
      color:rgba(29,30,30,1);
      top:0.02rem;
    }
    p {
      display: inline-block;
      font-size:0.15rem;
      font-weight:400;
      color:rgba(29,30,30,1);
      line-height:0.21rem;
      margin-left: 0.08rem;
    }
  }
  .cart_pro_list{
    border-radius: .04rem;
    background: #fff;
    margin: .1rem .11rem;
    padding: .1rem .15rem;
    .list{
      padding-bottom: .2rem;
      font-size: .14rem;
      position: relative;
    }
    .list:after{
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 0;
      bottom: 0;
      left: 0;
      border-bottom: 1px solid #D8D8D8;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
    .numtotal{
      font-size: .12rem;
      line-height: .45rem;
      text-align: right;
      color:#3D3D3D;
      .totalprice{
        color:#FC0324;
        font-size: .16rem;
      }
    }
  }
  .additional{
    border-radius: .04rem;
    background: #fff;
    margin: .1rem .11rem;
    /*padding: .15rem 0;*/
    overflow: hidden;
    .van-cell:not(:last-child)::after,.van-hairline--top-bottom::after{
      border: 0;
    }
    .txt{
      font-size: .12rem;
      color:#333333;
      flex: auto;
    }
  }
  .sub_bar{
    position: fixed;
    bottom: 0;
    left:0;
    width: 100%;
    height: .49rem;
    display: flex;
    align-items: center;
    font-size: .14rem;
    background: #fff;
    border-top:solid 1px rgba(0,0,0,0.25);
    padding: 0 .11rem;
    justify-content: space-between;
    .itemtxt{
      font-size: .12rem;
      color:#222222;
      width: 60%;
      .xprice {
        font-size: 0;
        line-height: .2rem;
      }
      b {
        font-size: .16rem;
        font-weight: 600;
      }
      sub {
        font-weight: normal;
        font-size: .12rem;
        vertical-align: baseline
      }
      sup {
        font-size: .11rem;
        vertical-align: baseline;
        font-weight: normal;
      }
    }
    .btton{
      background:linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
      border-radius:.19rem;
      font-size: .16rem;
      line-height: .22rem;
      padding: .07rem .16rem;
      text-align: center;
      color:#fff;
    }
  }
  .coupon{
    .coupon_item{
      position: relative;
      .coupon_info{
        background: url("../../assets/images/couponbg.png") center center no-repeat;
        background-size: 100% 100%;
        min-height: 1.07rem;
        width: 3.45rem;
        margin: 0 auto;
        margin-top: .1rem;
        position: relative;
        .f1{
          background: #FBF1DF;
          font-size: .12rem;
          text-align: center;
          width: 29.2%;
          float: left;
          span:nth-child(1) {
            display: block;
            font-size: .37rem;
            color:#B1243D;
            font-weight:600;
            line-height: .52rem;
            margin-top: .16rem;
            &:before {
              content: '￥';
              font-size:0.15rem;
              font-weight:600;
              color:rgba(177,36,61,1);
              line-height:0.21rem;
            }
          }
          span:nth-child(2) {
            color:#D43854;
            font-size: .12rem;
            transform: scale(0.85);
            text-align: center;
          }
        }
        .f2{
          float: left;
          position: relative;
          margin-left: .1rem;
          min-height: 1.07rem;
          width: 60%;
          overflow: hidden;
          span:nth-child(1){
            display: block;
            font-size: .15rem;
            line-height: .21rem;
            color:#292929;
            font-weight:600;
            margin-top: .23rem;
          }
          span:nth-child(2){
            label{
              transform: scale(0.8);
              display: block;
              margin-left: -10%;
            }
            font-size: .12rem;
            line-height: .18rem;
            color:#6B6B6B;
            display: block;
            margin-top: .08rem;
          }
        }
        .f3{
          position: absolute;
          top:.47rem;
          right:.1rem;
          font-size: .12rem;
          color:#fff;
          padding: .05rem .12rem;
          min-width: .6rem;
          text-align: center;
          background: #FC0324;
          border-radius: .14rem;
        }
        .f3.active{
            background: #DDDDDD;
        }
        .coupon_tit{
          font-size: .12rem;
          color:#999999;
          left:0;
          position: absolute;
          bottom: 0.05rem;
          width: 98%;
          padding-left: 29.2%;
          .tit_info{
            position: relative;
            padding-left: .1rem;
            .tit{
              float: left;
              transform: scale(0.85);
              margin-left: -0.03rem;
            }
            .van-icon{
              float: right;
              transform: scale(0.85);
            }
          }
        }
      }
      .coupon_desc{
        font-size: .12rem;
        line-height: .17rem;
        color:#848483;
        width: 3.45rem;
        margin: 0 auto;
        border: solid 1px rgba(237,214,173,0.5);
        border-top:0;
        padding: 0.06rem 0.1rem;
      }
    }
    .coupon_btn{
      width:3.53rem;
      height:.43rem;
      background:linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%);
      border-radius:.25rem;
      text-align: center;
      font-size: .17rem;
      line-height: .24rem;
      color:#fff;
      line-height: .43rem;
      margin: .1rem auto;
      margin-top: .2rem;
      span{
        font-size: .13rem;
      }
    }
  }
  .coupon_name{
    padding: .17rem 0;
    position: relative;
    font-size: .14rem;
    color:#222222;
    text-align: center;
    font-weight:400;
    img{
      position: absolute;
      right: .15rem;
      top:.17rem;
      width: .2rem;
      height: .2rem;
    }
  }
}
</style>
<style lang="scss">
  .container .additional .field .van-cell__title {
    width: 0.72rem;
  }
  .container .additional .van-cell__title span {
    font-size: 0.12rem;
  }
  .container .additional .van-cell__value .van-field__control {
    font-size: 0.12rem;
    line-height: 0.25rem;
  }
  .container .additional .van-cell__value .van-field__control::placeholder {
    font-size: 0.12rem;
    line-height: 0.25rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/prize/addOrderPrize.vue